export default "__VITE_ASSET__BAtz_j_X__"